var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilesdetailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.836,
    y1: 0.049,
    x2: 0.201,
    y2: 0.898,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#638beb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee4d91"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_65784",
    "data-name": "Group 65784",
    transform: "translate(-3121 -6983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65783",
    "data-name": "Group 65783"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_407",
    "data-name": "Ellipse 407",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(3121 6983)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-copy-3029269",
    transform: "translate(3128 6988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34564",
    "data-name": "Path 34564",
    d: "M12.5,2.766v.6H8.078A1.858,1.858,0,0,0,6.221,5.223v7.486H5.236a.766.766,0,0,1-.766-.766V2.766A.766.766,0,0,1,5.236,2h6.5A.766.766,0,0,1,12.5,2.766Z",
    transform: "translate(-4.47 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34565",
    "data-name": "Path 34565",
    d: "M17.341,6.94H11.169a.929.929,0,0,0-.929.929v8.852a.929.929,0,0,0,.929.929h6.172a.929.929,0,0,0,.929-.929V7.869A.929.929,0,0,0,17.341,6.94Zm-.711,7.732H11.865a.464.464,0,0,1,0-.929H16.63a.464.464,0,0,1,0,.929Zm0-1.913H11.865a.464.464,0,0,1,0-.929H16.63a.464.464,0,0,1,0,.929Zm0-1.913H11.865a.464.464,0,0,1,0-.929H16.63a.464.464,0,0,1,0,.929Z",
    transform: "translate(-7.56 -4.646)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesdetailicon);
export default __webpack_public_path__ + "static/media/filesdetailicon.a4cc67cec2b7b090c57d2c355c6eadf7.svg";
export { ForwardRef as ReactComponent };